import { mapState } from 'vuex'

import eventBus from 'lib/eventBus'

export default {
  name: 'membership-start',
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      user: (state) => state.user.current,
    }),
    affiliate() {
      return this.$store.state.membership.currentAffiliate || {}
    },
  },
  data() {
    return {}
  },
  methods: {
    startMembership() {
      this.$router.push({
        name: 'MembershipSelectPlan',
      })
    },
  },
  created() {
    this.$store.dispatch('setCurrentMembershipPlan', null)
  },
  updated() {
    eventBus.$emit('updated')
  },
}



// WEBPACK FOOTER //
// ./src/components/MembershipStart/script.js?vue&type=script&lang=js&